import { render, staticRenderFns } from "./PersonalizedEmails.vue?vue&type=template&id=2aad8f6b&scoped=true&"
import script from "./PersonalizedEmails.vue?vue&type=script&lang=js&"
export * from "./PersonalizedEmails.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedEmails.vue?vue&type=style&index=0&id=2aad8f6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad8f6b",
  null
  
)

export default component.exports